/* eslint-disable class-methods-use-this */
import _ from 'lodash';
import * as api from '../../../../utils/apiClient';
import { restructureUserFlowFundsModel } from './restructuring';
import { restructurePaginationModel } from '../../../../common/restructuring';

class UserFlowFundsService {
  async getUserFlowFundsAuthUser(state, queryParams) {
    const response = await api.get('/user-flow-funds/me', {
      expand: 'typeTransaction',
      ...queryParams
    });
    const responseJson = await response.json();
    if (!responseJson.success) {
      return {
        response: responseJson,
        destructData: null
      };
    }
    return {
      response: responseJson,
      destructData: {
        itemsById: _.keyBy(
          _.map(responseJson.data.items, item =>
            restructureUserFlowFundsModel(state, item)
          ),
          'id'
        ),
        itemsIds: _.map(responseJson.data.items, item => item.id),
        pagination: restructurePaginationModel(
          _.get(responseJson, 'data._meta')
        )
      }
    };
  }

  async transferFunds(state, body) {
    const response = await api.post(
      '/user-flow-funds/transfer-funds',
      {},
      body
    );
    const responseJson = await response.json();
    return responseJson;
  }
}

export default new UserFlowFundsService();



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/userFlowFunds/services/UserFlowFundsService/UserFlowFundsService.js